import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { colors } from '../../tokens/colors/colors.js';
import '../../tokens/shadows/shadows.js';
import '../../tokens/spacing/spacing.js';
import '../../tokens/breakpoints/breakpoints.js';

function Skeleton({ variant = "text", width, height, inline, style, }) {
    const size = getSize({
        variant,
        width,
        height,
    });
    return (jsx(StyledSkeleton, { "$variant": variant, "$width": size.width, "$height": size.height, "$inline": inline, style: style }));
}
function getSize({ variant, width, height, }) {
    switch (variant) {
        case "circle":
            return {
                width: width || 40,
                height: height || 40,
            };
        case "rect":
        default:
            return {
                width: width || "100%",
                height: height || 30,
            };
    }
}
const StyledSkeleton = styled.div `
  display: ${({ $inline }) => ($inline ? "inline-block" : "block")};
  width: ${({ $width }) => typeof $width === "number" ? `${$width}px` : $width};
  height: ${({ $height }) => typeof $height === "number" ? `${$height}px` : $height};
  border-radius: ${({ $variant }) => $variant === "circle" ? "9999px" : "4px"};
  ${({ $variant }) => $variant === "text" && "transform: scale(1, 0.6)"};
  background: ${colors.neutral};

  animation: fadeOut 1s alternate ease-in-out 0.5s infinite;

  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0.4;
    }
  }
`;

export { Skeleton };
